var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"padding":"10px"}},[_c('hr'),_c('h1',[_vm._v("Validated Form")]),_c(_setup.SimpleForm)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }